import { InjectionToken } from '@angular/core';

export const CurrentHotspotToken = new InjectionToken('CURRENT_HOTSPOT');
